import { render, staticRenderFns } from "./VesselTrial.vue?vue&type=template&id=c969e0ae&scoped=true&"
import script from "./VesselTrial.vue?vue&type=script&lang=js&"
export * from "./VesselTrial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c969e0ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
